import SharedLiveClassRoom from "@/components/feature/live-class/LiveClassRoom";

interface LiveClassRoomProps {
  title: string;
  roomCode: string;
  hostName: string;
  hostIdentity: string;
  onEnd: () => void;
  onExit: () => void;
}

export default function LiveClassRoom({
  title,
  roomCode,
  hostName,
  hostIdentity,
  onEnd,
  onExit,
}: LiveClassRoomProps) {
  return (
    <SharedLiveClassRoom
      title={title}
      roomCode={roomCode}
      userName={hostName}
      isHost
      hostIdentity={hostIdentity}
      onEnd={onEnd}
      onExit={onExit}
    />
  );
}